import { use_slice_generation } from '@/hooks/store/use_slices';
import { assert_false, assert_true } from '@shared/asserts/utils_asserts';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD_PRIMITIVE__bool } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__bool';
import { FIELD_PRIMITIVE__seed } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__seed';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { FIELD__list_lora } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_lora';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { FIELD_PRIMITIVE__base_number } from '@shared/dto/generation/graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__base_number';
import { FIELD_PRIMITIVE__int_image_side } from '@shared/dto/generation/graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__int_image_side';
import { FIELD_PRIMITIVE__base_string } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/FIELD_PRIMITIVE__base_string';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { FIELD__ml_asset_control_net } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance/FIELD__ml_asset_control_net';
import { FIELD__ml_asset_t2i_adapter } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance/FIELD__ml_asset_t2i_adapter';
import { FIELD_GRID2D_MODE__all_loras_except_one } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__all_loras_except_one';
import { FIELD_GRID2D_MODE__lora_after_lora } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__lora_after_lora';
import { FIELD_GRID2D_MODE__lora_vs_lora } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__lora_vs_lora';
import { FIELD_GRID2D_MODE__single_lora_generation } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__single_lora_generation';
import { FIELD_GRID2D_MODE__all_tokens_except_one } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD_GRID2D_MODE__all_tokens_except_one';
import { FIELD_GRID2D_MODE__single_token_generation } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD_GRID2D_MODE__single_token_generation';
import { FIELD_GRID2D_MODE__token_after_token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD_GRID2D_MODE__token_after_token';
import { FIELD_GRID2D_MODE__token_vs_token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD_GRID2D_MODE__token_vs_token';
import { useMemo } from 'react';
import { G_UI_FIELD__output } from './_base/G_UI_FIELD__output';
import { G_UI_FIELD__wrapper } from './_base/G_UI_FIELD__wrapper';
import { G_UI_GRID2D_MODE__both_dimensions } from './grid2d_mode/G_UI_GRID2D_MODE__both_dimensions';
import { G_UI_GRID2D_MODE__row_or_column } from './grid2d_mode/G_UI_GRID2D_MODE__row_or_column';
import { G_UI_FIELD__image_asset } from './image_asset/G_UI_FIELD__image_asset';
import { G_UI_FIELD__image_asset_list } from './image_asset_list/G_UI_FIELD__image_asset_list';
import { G_UI_FIELD__ml_asset_control_net } from './ml_asset/G_UI_FIELD__ml_asset_control_net';
import { G_UI_FIELD__ml_asset_t2i_adapter } from './ml_asset/G_UI_FIELD__ml_asset_t2i_adapter';
import { G_UI_FIELD__ml_asset_lora_list } from './ml_asset_lora/G_UI_FIELD__ml_asset_lora_list';
import { G_UI_FIELD_PRIMITIVE__bool_master } from './primitive_bool/G_UI_FIELD_PRIMITIVE__bool_master';
import { G_UI_FIELD_PRIMITIVE__int_image_side } from './primitive_number/G_UI_FIELD_PRIMITIVE__int_image_side';
import { G_UI_FIELD_PRIMITIVE__number } from './primitive_number/G_UI_FIELD_PRIMITIVE__number';
import { G_UI_FIELD_PRIMITIVE__string } from './primitive_string/G_UI_FIELD_PRIMITIVE__string';
import { G_UI_FIELD_PRIMITIVE__string_ml_asset_hash } from './primitive_string_ml_asset_hash/G_UI_FIELD_PRIMITIVE__string_ml_asset_hash';
import { G_UI_FIELD__seed_master } from './seed/G_UI_FIELD__seed_master';
import { G_UI_FIELD__token_list } from './token/_list/G_UI_FIELD__token_list';
import { G_UI_FIELD__token_list_add_special_tokens } from './token/_list_add_special_tokens/G_UI_FIELD__token_list_add_special_tokens';

interface PROPS {
  fields: FIELD__base[];
  class_name?: string;
}

export function G_SIDEBAR__fields({ fields, class_name = '' }: PROPS) {
  /*
   * STORE
   */
  const { generation_current } = use_slice_generation(['generation_current']);

  const { graph } = generation_current.tool;

  const fields_list = useMemo(() => get_fields_list(), [graph, fields]);

  /*
   *
   */

  function get_fields_list() {
    let out_map = new MAP__serializable<string, FIELD__base>();

    for (let field of fields) {
      if (field.meta.graph_id != graph.meta.graph_id) continue;

      field = field.find_source(graph);
      out_map.set(field.meta.field_id, field);
    }

    let out = out_map.values();

    out = out.sort(FIELD__base.sort_group_by_sort_criteria);

    return out;
  }

  /*
   * RENDERS
   */

  function render_field(field: FIELD__base, index: number) {
    assert_true(field.meta.ui__has_component);
    assert_false(field.is_stub());

    let out = <></>;

    let { data__is_linked } = field.meta;

    if (data__is_linked) {
      field = graph.field__get_source_for(field);
    }

    if (field.meta.kind__is_output) {
      out = <G_UI_FIELD__output {...{ field }} />;
    } else if (field instanceof FIELD_PRIMITIVE__seed) {
      out = <G_UI_FIELD__seed_master {...{ field }} />;
    } else if (field instanceof FIELD__list_token) {
      out = (
        <>
          <G_UI_FIELD__token_list {...{ field }} />
          <G_UI_FIELD__token_list_add_special_tokens {...{ field }} />
        </>
      );
    } else if (field instanceof FIELD_PRIMITIVE__string_hash_ml_asset) {
      out = <G_UI_FIELD_PRIMITIVE__string_ml_asset_hash {...{ field }} />;
    } else if (field instanceof FIELD_PRIMITIVE__base_string) {
      out = <G_UI_FIELD_PRIMITIVE__string {...{ field }} />;
    } else if (field instanceof FIELD_PRIMITIVE__int_image_side) {
      out = <G_UI_FIELD_PRIMITIVE__int_image_side {...{ field }} />;
    } else if (field instanceof FIELD_PRIMITIVE__base_number) {
      out = <G_UI_FIELD_PRIMITIVE__number {...{ field }} />;
    } else if (field instanceof FIELD_PRIMITIVE__bool) {
      out = <G_UI_FIELD_PRIMITIVE__bool_master {...{ field }} />;
    } else if (field instanceof FIELD__image_asset) {
      out = <G_UI_FIELD__image_asset {...{ field }} />;
    } else if (field instanceof FIELD__list_image_asset) {
      out = <G_UI_FIELD__image_asset_list {...{ field }} />;
    } else if (field instanceof FIELD__ml_asset_control_net) {
      out = <G_UI_FIELD__ml_asset_control_net {...{ field }} />;
    } else if (field instanceof FIELD__ml_asset_t2i_adapter) {
      out = <G_UI_FIELD__ml_asset_t2i_adapter {...{ field }} />;
    } else if (field instanceof FIELD__list_lora) {
      out = <G_UI_FIELD__ml_asset_lora_list {...{ field }} />;
    }
    //
    //
    //
    else if (field instanceof FIELD_GRID2D_MODE__lora_vs_lora) {
      out = <G_UI_GRID2D_MODE__both_dimensions {...{ field }} />;
    }
    //
    //
    else if (field instanceof FIELD_GRID2D_MODE__lora_after_lora) {
      out = <G_UI_GRID2D_MODE__row_or_column {...{ field }} />;
    }
    //
    else if (field instanceof FIELD_GRID2D_MODE__single_lora_generation) {
      out = <G_UI_GRID2D_MODE__row_or_column {...{ field }} />;
    }
    //
    else if (field instanceof FIELD_GRID2D_MODE__all_loras_except_one) {
      out = <G_UI_GRID2D_MODE__row_or_column {...{ field }} />;
    }
    //
    //
    //
    else if (field instanceof FIELD_GRID2D_MODE__token_vs_token) {
      out = <G_UI_GRID2D_MODE__both_dimensions {...{ field }} />;
    }
    //
    else if (field instanceof FIELD_GRID2D_MODE__token_after_token) {
      out = <G_UI_GRID2D_MODE__row_or_column {...{ field }} />;
    }
    //
    else if (field instanceof FIELD_GRID2D_MODE__single_token_generation) {
      out = <G_UI_GRID2D_MODE__row_or_column {...{ field }} />;
    }
    //
    else if (field instanceof FIELD_GRID2D_MODE__all_tokens_except_one) {
      out = <G_UI_GRID2D_MODE__row_or_column {...{ field }} />;
    }
    //
    //
    //
    else {
      out = <div className="text-gray-300">{JSON.stringify(field)}</div>;
    }

    let is_small_amount_of_fields = fields_list.length < 4;

    let className = is_small_amount_of_fields ? 'flex-1' : 'max-h-96';

    assert_false(field.meta.data__is_linked);

    return (
      <G_UI_FIELD__wrapper {...{ field, className }} key={field.meta.field_id} data__is_linked={data__is_linked}>
        {out}
      </G_UI_FIELD__wrapper>
    );
  }

  function render_fields() {
    return fields_list.map(render_field);
  }

  /*
   * HTML
   */

  return <div className={`w-full flex-1 bg-bar  min-w-0 min-h-0 ${class_name}`}>{render_fields()}</div>;
}
